import { render, staticRenderFns } from "./CampaignSetupsListRowDropdown.vue?vue&type=template&id=7b242df0&scoped=true"
import script from "./CampaignSetupsListRowDropdown.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsListRowDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b242df0",
  null
  
)

export default component.exports